import React from 'react';
import TimeLineContent from "./time-line-content.jsx";
import DayOfWeekContent from "./day-of-week-content.jsx";

const TemporalContent = ({ data, collapsed, startDate, endDate }) => {
    return (
        <>
            <div id="temporal">

                <div className="report-divisor mb-6 print:break-after-avoid!">
                    <span className="divisor-title">
                        ANÁLISE TEMPORAL
                    </span>
                </div>

                <TimeLineContent key={`timeline-${collapsed}`} data={data} startDate={startDate} endDate={endDate}/>
                <DayOfWeekContent key={`dow-${collapsed}`} data={data}/>

            </div>
        </>
    );
};

export default TemporalContent;